import TabInfo from '../../../../common/TabController/TabInfo';
import ImportProteinTab from './ImportProteinTab';
import ImportPdbTab from './ImportPdbTab';
import ImportAlphaFoldTab from './ImportAlphaFoldTab';
import SelectProteinTab from './SelectProteinTab';
import ProjectTargetsTab from './ProjectTargetsTab';
import { Loader } from '../../../../../Loader';
import SelectActiveSoluteTab from './SelectActiveSoluteTab';
import ProteinFoldingTab from './ProteinFoldingTab';
import JobsStructuresTab from './JobsStructuresTab';

const tabs = [
    new TabInfo(
        'protein_search_tab',
        'Structure Search',
        SelectProteinTab,
        {
            viewOnlyOK: true,
        },
    ),
    new TabInfo(
        'protein_folding_tab',
        'Protein Folding',
        ProteinFoldingTab,
        {
            viewOnlyOK: true,
        },
    ),
    new TabInfo(
        'import_protein_tab',
        'Upload Protein Data',
        ImportProteinTab,
    ),
    new TabInfo(
        'jobs_structures_tab',
        'Folding Job Results',
        JobsStructuresTab,
        {
            ModalPaneProps: {
                style: {
                    height: '100%',
                    maxWidth: 'none',
                },
            },
        }
    ),
    new TabInfo(
        'import_pdb_tab',
        'Import from PDB',
        ImportPdbTab
    ),
    new TabInfo(
        'import_alphafold_tab',
        'Import from AlphaFold',
        ImportAlphaFoldTab
    ),
];

if (Loader.AllowLabFeatures) {
    tabs.push(
        new TabInfo(
            'project_target_tab',
            'Project / Targets',
            ProjectTargetsTab,
            {
                ModalPaneProps: {
                    style: {
                        height: '100%',
                        maxWidth: 'none',
                    },
                },
            }
        )
    );
}

if (Loader.AllowDevFeatures) {
    tabs.push(
        new TabInfo(
            'solute_selector_tab',
            'Solute selector',
            SelectActiveSoluteTab,
        )
    );
}

export default tabs;
